import { render, staticRenderFns } from "./expensesChart.vue?vue&type=template&id=93036b86"
import script from "./expensesChart.vue?vue&type=script&lang=js"
export * from "./expensesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports